import styled from 'styled-components';
import { createGradientOrSolid } from '../../Helper/utils/utils';

export const StyledApplovinBundle = styled.div`
    height: 172px;
    aspect-ratio: 1/1;
    margin: 0 auto;
    border-radius: ${(props: any) => `${props.borderRadius || 18}px`};
    background: ${(props: any) =>
        createGradientOrSolid(props.bundleBorderColor)};
    font-family: ${(props: any) => props.fontFamily};
    position: relative;
    display: flex;
    flex-direction: column;

    .part {
        height: 100%;
        box-sizing: border-box;

        &.upper {
            background-color: black;
            border-radius: ${(props: any) => `${props.borderRadius || 18}px`};
            background: ${(props: any) => 
                props.backgroundSrc
                    ? `url("${props.backgroundSrc}")`
                    : createGradientOrSolid(props.backgroundColor)};
            background-size: cover;
        }

        &.lower {
            max-height: 50px;
            border-bottom-right-radius: ${(props: any) => `${props.borderRadius || 18}px`};
            border-bottom-left-radius: ${(props: any) => `${props.borderRadius || 18}px`};
            display: flex;
            align-items: center;
            text-align: center;
            justify-content: center;
            color: white;
            font-size: 14px;
            
            p {
                margin: auto;
            }
        }
    }

    span {
        @supports (-webkit-text-stroke: 1px black) {
            -webkit-text-fill-color: ${(props: any) => props.textColor};
        } else {
            text-shadow: 0px 1px 0px rgba(0, 0, 0, 0.8);
            color: ${(props: any) => props.textColor};
        }
    }

    @media (min-width: 768px) {
        height: 284px;

        .part.lower {
            max-height: 84px;
        }
    }
` as any;

export const StyledProduct = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;

    img {
        object-fit: contain;

        &.mainPic {
            height: 80px;
        }
        &.prefixPic {
            position: absolute;
            right: 105%;
            height: 80%;
        }
    }

    .text {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        max-height: 30px;

        span {
            margin: 0;
            text-align: center;
            font-size: 20px;
            font-weight: 900;
            color: black;
            -webkit-text-stroke: 1px rgba(97, 14, 255, 1);
        }
    }

    @media (min-width: 768px) {
        img {
            &.mainPic {
                height: 120px;
            }
        }

        .text span.quantity {
            font-size: 30px;
            -webkit-text-stroke: 1.7px rgba(97, 14, 255, 1);
        }
    }
` as any;
